export const osnTop101SIcon = {
  data: `<svg viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5"
d="M141.6 203V16.24H106.88L48.08 75.32L70.76 99.12L101.56 67.48V203H141.6Z" fill="#0F0125" stroke="currentColor"
stroke-width="13"/></svg>`,
  name: 'top-10-1-s',
};
